// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file tock/patron.proto (package com.americanexpress.dining.tock.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file tock/patron.proto.
 */
export const file_tock_patron: GenFile = /*@__PURE__*/
  fileDesc("ChF0b2NrL3BhdHJvbi5wcm90bxIlY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcudG9jay5wcm90byL7AwoKVG9ja1BhdHJvbhIWCglzaG9ydF9iaW8YASABKAlIAIgBARIcChRkaWV0YXJ5X3Jlc3RyaWN0aW9ucxgCIAMoCRIbCg5mb29kX2F2ZXJzaW9ucxgDIAEoCUgBiAEBEh8KEmNhbl9ib29rX2Zvcl9ndWVzdBgEIAEoCEgCiAEBEkoKCGJpcnRoZGF5GAUgASgLMjMuY29tLmFtZXJpY2FuZXhwcmVzcy5kaW5pbmcudG9jay5wcm90by5Ub2NrQmlydGhkYXlIA4gBARISCgVlbWFpbBgGIAEoCUgEiAEBEhIKBXBob25lGAcgASgJSAWIAQESEwoGc3RhdHVzGAggASgJSAaIAQESRAoIcGFydG5lcnMYCSADKAsyMi5jb20uYW1lcmljYW5leHByZXNzLmRpbmluZy50b2NrLnByb3RvLlRvY2tQYXJ0bmVyEhcKCmNyZWF0ZWRfYXQYCiABKAlIB4gBARIeChZndWVzdF9wcm9maWxlX2dyb3VwX2lkGAsgAygEQgwKCl9zaG9ydF9iaW9CEQoPX2Zvb2RfYXZlcnNpb25zQhUKE19jYW5fYm9va19mb3JfZ3Vlc3RCCwoJX2JpcnRoZGF5QggKBl9lbWFpbEIICgZfcGhvbmVCCQoHX3N0YXR1c0INCgtfY3JlYXRlZF9hdCJiCgxUb2NrQmlydGhkYXkSEAoDZGF5GAEgASgNSACIAQESEgoFbW9udGgYAiABKA1IAYgBARIRCgR5ZWFyGAMgASgNSAKIAQFCBgoEX2RheUIICgZfbW9udGhCBwoFX3llYXIiQQoLVG9ja1BhcnRuZXISDwoCaWQYASABKARIAIgBARIRCgRuYW1lGAIgASgJSAGIAQFCBQoDX2lkQgcKBV9uYW1lQikKJWNvbS5hbWVyaWNhbmV4cHJlc3MuZGluaW5nLnRvY2sucHJvdG9QAWIGcHJvdG8z");

/**
 * @generated from message com.americanexpress.dining.tock.proto.TockPatron
 */
export type TockPatron = Message<"com.americanexpress.dining.tock.proto.TockPatron"> & {
  /**
   * @generated from field: optional string short_bio = 1;
   */
  shortBio?: string;

  /**
   * @generated from field: repeated string dietary_restrictions = 2;
   */
  dietaryRestrictions: string[];

  /**
   * @generated from field: optional string food_aversions = 3;
   */
  foodAversions?: string;

  /**
   * concierge status
   *
   * @generated from field: optional bool can_book_for_guest = 4;
   */
  canBookForGuest?: boolean;

  /**
   * @generated from field: optional com.americanexpress.dining.tock.proto.TockBirthday birthday = 5;
   */
  birthday?: TockBirthday;

  /**
   * @generated from field: optional string email = 6;
   */
  email?: string;

  /**
   * @generated from field: optional string phone = 7;
   */
  phone?: string;

  /**
   * e.g. ACTIVE, ADMIN_LOCKED_OUT, NEW_USER_REQUIRES_CONFIRMATION, ZOMBIE
   *
   * @generated from field: optional string status = 8;
   */
  status?: string;

  /**
   * @generated from field: repeated com.americanexpress.dining.tock.proto.TockPartner partners = 9;
   */
  partners: TockPartner[];

  /**
   * @generated from field: optional string created_at = 10;
   */
  createdAt?: string;

  /**
   * @generated from field: repeated uint64 guest_profile_group_id = 11;
   */
  guestProfileGroupId: bigint[];
};

/**
 * Describes the message com.americanexpress.dining.tock.proto.TockPatron.
 * Use `create(TockPatronSchema)` to create a new message.
 */
export const TockPatronSchema: GenMessage<TockPatron> = /*@__PURE__*/
  messageDesc(file_tock_patron, 0);

/**
 * @generated from message com.americanexpress.dining.tock.proto.TockBirthday
 */
export type TockBirthday = Message<"com.americanexpress.dining.tock.proto.TockBirthday"> & {
  /**
   * @generated from field: optional uint32 day = 1;
   */
  day?: number;

  /**
   * @generated from field: optional uint32 month = 2;
   */
  month?: number;

  /**
   * @generated from field: optional uint32 year = 3;
   */
  year?: number;
};

/**
 * Describes the message com.americanexpress.dining.tock.proto.TockBirthday.
 * Use `create(TockBirthdaySchema)` to create a new message.
 */
export const TockBirthdaySchema: GenMessage<TockBirthday> = /*@__PURE__*/
  messageDesc(file_tock_patron, 1);

/**
 * @generated from message com.americanexpress.dining.tock.proto.TockPartner
 */
export type TockPartner = Message<"com.americanexpress.dining.tock.proto.TockPartner"> & {
  /**
   * @generated from field: optional uint64 id = 1;
   */
  id?: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;
};

/**
 * Describes the message com.americanexpress.dining.tock.proto.TockPartner.
 * Use `create(TockPartnerSchema)` to create a new message.
 */
export const TockPartnerSchema: GenMessage<TockPartner> = /*@__PURE__*/
  messageDesc(file_tock_patron, 2);

